<!-- Device-mode boot screen: shown ONLY when ?isDevice=true (or
     localStorage.isDeviceMode is set from a prior boot). The cashier
     never sees the login form on a paired POS device — a separate
     unlock popup gates access after the staff session is restored. -->
<div class="device-boot" *ngIf="isDeviceLoading">
    <div class="device-boot__panel">
        <img class="device-boot__logo" src="./assets/default-logo.png" alt="logo"/>
        <mat-progress-bar class="device-boot__bar" mode="indeterminate"></mat-progress-bar>
        <p class="device-boot__caption">Starting device…</p>
    </div>
</div>

<!-- Default paymentForm login -->
<div class="parent" *ngIf="!isDeviceLoading">
    <form [formGroup]="loginForm" class="element text-center border border-light p-5">
        <div class="login-items-container">
            <i class="material-icons arrow-back-icon back-icon" routerLink="/home">arrow_back</i>
            <img class="i1" src="./assets/default-logo.png" alt="logo"/>
            <!--    <p class="h4 mb-4">SIGN IN</p>-->

            <!-- Email -->
            <input formControlName="username" type="email" class="form-control mb-4"
                   placeholder="E-mail"
                   [ngClass]="{ 'is-invalid': (submitted && f.username.errors) || passwordResetEmailMissing }"/>
            <div class="error-message" *ngIf="errorMessage">{{errorMessage}}</div>
            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                <div *ngIf="f.username.errors.required">Username is required</div>
            </div>
            <div *ngIf="passwordResetEmailMissing" class="invalid-feedback">
                <div>Enter the Email or Phone Number</div>
            </div>
            <!-- Credential — single field that accepts either an account
                 password OR a 4-8 digit clockInPin. On a paired POS device
                 (isDeviceMode) the placeholder reads "PIN or password" so the
                 cashier knows a PIN is accepted. The BE attempts PIN first then
                 password, so we forward the value under both keys when it
                 looks like a PIN — the auto-detect lives in
                 AuthenticationService.login().
                 NOTE: we intentionally do NOT set inputmode="numeric" here.
                 On Android WebView a numeric inputmode gives a digits-only
                 keypad, which makes an alphanumeric password impossible to
                 type on a device. The default keyboard already includes
                 digits, so it serves both PIN and password entry. -->
            <input formControlName="password" type="password" class="form-control mb-4"
                   [placeholder]="isDeviceMode ? 'PIN or password' : 'Password'"
                   [ngClass]="{ 'is-invalid': submitted && f.password.errors }"/>
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                <div *ngIf="f.password.errors.required">Password is required</div>
            </div>
            <!-- PIN lockout banner: the BE rate-limits PIN-only retries and
                 returns "Too many PIN attempts. Try password or wait 10
                 minutes." once tripped. Surfaced inline (not via the generic
                 alert) so the user understands password is still allowed. -->
            <div class="pin-lockout-banner" *ngIf="pinLockoutMessage">{{pinLockoutMessage}}</div>
            <alert></alert>

            <!-- Sign in button -->
            <button mdbBtn block="true" class="login-button my-4 button-flex" type="submit" [disabled]="loading" (click)="onSubmit()">Sign in
                <mat-spinner class="spinner-loader" diameter="20" *ngIf="loading"></mat-spinner>
            </button>

            <div class="reset-button-container">
                <p><a class="btn-link" (click)="resetPassword()">Forgot password?</a></p> <div class="password-reset-or">|</div>
                <p><a [routerLink]="['/register']" class="btn-link">Register (New User)</a></p>
            </div>
            <div class="hr">
                <span> OR </span>
            </div>
            <button mdbBtn  block="true" class="otp-login-button my-4 button-flex" routerLink="/login-code" [disabled]="loading">OTP Login
                <mat-spinner class="spinner-loader" diameter="20" *ngIf="loading"></mat-spinner>
            </button>

            <button mdbBtn block="true" class="clover-login-button my-4 button-flex" type="submit" [disabled]="loading" (click)="reauthenticateRouter(Constants.CLOVER)">Sign in with Clover
                <mat-spinner class="spinner-loader" diameter="20" *ngIf="loading"></mat-spinner>
            </button>

            <button mdbBtn *ngIf="false" block="true" class="square-login-button my-4 button-flex" type="submit" [disabled]="true" title="Coming Soon" (click)="reauthenticateRouter(Constants.SQUARE)">Sign in with Square
                <mat-spinner class="spinner-loader" diameter="20" *ngIf="loading"></mat-spinner>
            </button>
            <!-- Register -->
            <!-- Social login
            <p>or sign in with:</p>

            <a type="button" class="light-blue-text mx-2">
               <i class="fab fa-facebook-f"></i>
              <mdb-icon fab icon="facebook"></mdb-icon>
            </a>
            <a type="button" class="light-blue-text mx-2">
               <i class="fab fa-twitter"></i>
              <mdb-icon fab icon="twitter"></mdb-icon>
            </a>
            <a type="button" class="light-blue-text mx-2">
               <i class="fab fa-linkedin-in"></i>
              <mdb-icon fab icon="linkedin"></mdb-icon>
            </a>
            <a type="button" class="light-blue-text mx-2">
               <i class="fab fa-github"></i>
              <mdb-icon fab icon="github"></mdb-icon>
            </a>
            -->
        </div>
    </form>
    <!-- Default paymentForm login -->
</div>
